import React, {Component} from 'react';
import {
  createEnhancedStore,
  connectAuthSync,
} from '@tkww/ads-content-component-favorite-button/lib/store';
import {ToastBannerContainer} from '@tkww/ads-content-component-toast-banner';
import FavoriteImageButton from './favorite-button';

export default class FavoriteComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      store: null,
      shouldLoadToastBanner: false,
    };
  }

  componentDidMount() {
    let store = window.FavoritesStore || null;
    const {inStickyHeader} = this.props;

    if(inStickyHeader) {
      const objectId = this.getFavoriteAttributeObject();
      store = createEnhancedStore([objectId], 23);
      connectAuthSync(store);
    }
    
    const existingToastBanner = document.getElementById('toast-banner-loaded');
    const shouldLoadToastBanner = !existingToastBanner;

    if (shouldLoadToastBanner) {
      const markerDiv = document.createElement('div');
      markerDiv.id = 'toast-banner-loaded';
      markerDiv.style.position = 'absolute';
      markerDiv.style.visibility = 'hidden';
      document.body.appendChild(markerDiv);
    }

    this.setState({
      store,
      shouldLoadToastBanner,
    });
  }

  getFavoriteAttributeObject() {
    const {id} = this.props;
    return id;
  }

  render() {
    const {store, shouldLoadToastBanner} = this.state;

    return (
      <>
        {shouldLoadToastBanner && <ToastBannerContainer />}
        {store && <FavoriteImageButton store={store} {...this.props} />}
      </>
    );
  }
}
